import { render, staticRenderFns } from "./ModeloDocumento.vue?vue&type=template&id=4bc65500&scoped=true"
import script from "./ModeloDocumento.vue?vue&type=script&lang=js"
export * from "./ModeloDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc65500",
  null
  
)

export default component.exports